<!--
 * @Author: DYM
 * @Date: 2020-03-17 17:41:10
 * @LastEditors: DQL
 * @LastEditTime: 2022-01-28 15:43:16
 * @Description: 用户身份新增
 -->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-60 o-dialog--lg-50 o-dialog--xl-36"
    :title="dlTitle"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <section>
      <el-form
        ref="fd"
        class="c-form"
        :model="fd"
        :rules="fdRules"
        :inline="true"
        label-position="right"
        label-width="120px"
        label-suffix="："
      >
        <el-row
          class="c-form__row"
        >
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="身份代码"
              prop="capacityCode"
            >
              <template v-if="dlType==='add'">
                <el-input
                  v-model.trim="fd.capacityCode"
                  class="c-form__input"
                  placeholder=""
                />
              </template>
              <template v-else>
                <span
                  class="c-form__read"
                >
                  {{ fd.capacityCode }}
                </span>
              </template>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="身份名称"
              prop="capacityName"
            >
              <el-input
                v-model.trim="fd.capacityName"
                class="c-form__input"
                placeholder=""
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="身份有效期起"
              prop="effectStartDate"
            >
              <el-date-picker
                v-model="fd.effectStartDate"
                class="c-form__date"
                type="date"
                placeholder="选择日期"
                value-format="timestamp"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="身份有效期止"
              prop="effectEndDate"
            >
              <el-date-picker
                v-model="fd.effectEndDate"
                class="c-form__date"
                type="date"
                placeholder="选择日期"
                value-format="timestamp"
              />
            </el-form-item>
          </el-col>
          <el-col
            v-for="(attrCapacityItem, index) in attrCapacityList"
            :key="'attrCapacity'+ index"
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              :label="attrCapacityItem.attrName"
              :prop="'attrs.'+[attrCapacityItem.attrKey]"
            >
              <template v-if="attrCapacityItem.enums">
                <template v-if="enums[attrCapacityItem.enums] && Object.keys(enums[attrCapacityItem.enums]).length<=2">
                  <el-radio-group
                    v-model="fd.attrs[attrCapacityItem.attrKey]"
                    class="c-form__radio-group"
                  >
                    <el-radio
                      v-for="value in enums[attrCapacityItem.enums]"
                      :key="value.id"
                      :label="value.id"
                    >
                      {{ value.text }}
                    </el-radio>
                  </el-radio-group>
                </template>
                <template v-else>
                  <el-select
                    v-model="fd.attrs[attrCapacityItem.attrKey]"
                    class="c-form__select"
                    style="width: 100%;"
                    placeholder=""
                    clearable
                  >
                    <el-option
                      v-for="(value) in enums[attrCapacityItem.enums]"
                      :key="value.id"
                      :label="value.text"
                      :value="value.id"
                    />
                  </el-select>
                </template>
              </template>
              <template v-else-if="attrCapacityItem.attrType==='String'">
                <el-input
                  v-model.trim="fd.attrs[attrCapacityItem.attrKey]"
                  class="c-form__input"
                  placeholder=""
                />
              </template>
              <template v-else-if="attrCapacityItem.attrType==='Date'">
                <el-date-picker
                  v-model.trim="fd.attrs[attrCapacityItem.attrKey]"
                  class="c-form__date"
                  type="date"
                  placeholder="选择日期"
                  value-format="timestamp"
                />
              </template>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="所属组织"
              prop="deptName"
            >
              <span
                class="c-form__read"
              >
                {{ fd.deptName }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            v-if="dlType==='edit'"
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="是否有效"
              prop="valid"
            >
              <el-radio-group
                v-model="fd.valid"
                class="c-form__radio-group"
              >
                <el-radio label="Y">
                  有效
                </el-radio>
                <el-radio label="N">
                  无效
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </section>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <el-button
        type="primary"
        @click="handleSave()"
      >
        保存
      </el-button>
      <el-button
        @click="closeDialog()"
      >
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { capacityService } from '../user.service';

export default {
  name: 'AttrUpdateCapacity',
  props: {
    dlParams: {
      type: Object,
      default: () => {
        return {};
      }
    },
    // 扩展字段列表
    attrCapacityList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data () {
    return {
      dialogShow: true, // 模态框dialog显示
      loading: false, // 页面loading状态

      /* 表单参数 Start */
      fd: {
        capacityName: null, // 身份名称
        capacityCode: null, // 身份代码
        deptCode: null, // 部门代码
        effectEndDate: null, // 有效期止
        effectStartDate: null, // 有效期起
        userCode: null, // 用户代码
        positionId: null, // 职位
        valid: 'Y', // 有效标志
        deptName: null, // 所属组织
        attrs: {} // 扩展字段
      },
      /* 表单参数 End */

      /* 表单校验规则 Start */
      fdRules: {
        capacityCode: [
          this.$validUtils.required('身份代码'),
          this.$HMValidator.maxLength('身份代码', 36)
        ],
        capacityName: [
          this.$validUtils.required('身份名称'),
          this.$HMValidator.maxLength('身份名称', 113)
        ],
        effectStartDate: [
          this.$validUtils.required('身份有效期起'),
          this.$HMValidator.startTime(this, 'fd', 'effectEndDate', ['身份有效期起', '身份有效期止'])
        ],
        effectEndDate: [
          this.$validUtils.required('身份有效期止'),
          this.$HMValidator.endTime(this, 'fd', 'effectStartDate', ['身份有效期起', '身份有效期止'])
        ]
      },
      /* 表单校验规则 End */

      positionList: [], // 职位列表

      dlType: 'add' // 模态框类型，'add': 新增，'edit': 修改
    };
  },
  computed: {
    // 获取枚举
    enums () {
      const baseEnums = this.$HMStoreService.getEnums();
      const apiEnumsObj = this.$store.state.apiEnums;
      const apiKey = Object.keys(apiEnumsObj);
      let apiEnums = {};
      apiKey.forEach(_key => {
        apiEnums = Object.assign({}, apiEnums, apiEnumsObj[_key]);
      });
      return Object.assign({}, baseEnums, apiEnums);
    },
    /* 根据模态框类型动态展示标题 */
    dlTitle () {
      return `用户身份${this.dlType === 'edit' ? '修改' : '新增'}`;
    }
  },
  methods: {
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    },
    /**
     * @description: 初始化扩展字段
     * @param {*}
     * @return {*}
     */
    initAttr () {
      this.attrCapacityList.map(attrCapacityItem => {
        this.attrSetToData(attrCapacityItem, this.fd.attrs, this.fdRules, 'attrs.' + attrCapacityItem.attrKey);
      });
    },
    /**
     * @description: 设置扩展字段到form表单数据、规则中
     * @param {Object} _attr 扩展字段
     * @param {Object} _formVo 表单数据对象
     * @param {Object} _formRules 校验规则对象
     * @param {String} _formRuleAttr 校验规则的属性
     * @return {*}
     */
    attrSetToData (_attr, _formVo, _formRules, _formRuleAttr) {
      this.$set(_formVo, _attr.attrKey, null);
      // 设置扩展字段校验规则
      this.$set(_formRules, _formRuleAttr, []);
      //  若扩展字段有必填标志，添加必填校验
      if (_attr.attrRequired === 'Y') {
        this.$set(_formRules, _formRuleAttr, [
          this.$validUtils.required(_attr.attrName)
        ]);
      }
      // 若扩展字段有自定义的校验规则，添加自定义的校验规则
      if (_attr.patterns) {
        const patterns = (_field, pattern) => {
          return {
            pattern: patterns,
            message: `【${_field}】校验不通过`,
            trigger: ['blur', 'change']
          };
        };
        // 向已有扩展字段校验规则数组末添加自定义校验规则
        this.$set(_formRules[_formRuleAttr], _formRules[_formRuleAttr].length,
          patterns(_attr.attrName, _attr.patterns));
      }
    },
    /**
     * @description: 页面初始化
     * @param {*}
     * @return {*}
     */
    init () {
      this.loading = true;
      capacityService.getCapacity(this.dlParams.capacityCode)
        .then(rsp => {
          this.fd = Object.assign({}, this.fd, rsp.data);
          this.attrCapacityList.map(attrCapacityItem => {
            this.fd.attrs[attrCapacityItem.attrKey] = this.fd[attrCapacityItem.attrKey];
            this.$delete(this.fd, attrCapacityItem.attrKey);
          });
        })
        .catch(err => {
          console.error('获取初始化数据出错！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 保存操作
     * @param {*}
     * @return {*}
     */
    handleSave () {
      this.$refs.fd.validate((valid) => {
        if (valid) {
          this.loading = true;
          if (this.dlType === 'add') {
            this.addSave();
          } else {
            this.updateSave();
          }
        }
      });
    },
    /**
     * @description: 新增保存方法
     * @param {*}
     * @return {*}
     */
    addSave () {
      capacityService.save(this.fd)
        .then(rsp => {
          this.$alert('新增成功！', '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: action => {
            }
          });
          this.$emit('closeDialog', '');
          this.$emit('callback');
        })
        .catch(err => {
          console.error('获取初始化数据出错！', err);
          this.loading = false;
        });
    },
    /**
     * @description: 修改保存方法
     * @param {*}
     * @return {*}
     */
    updateSave () {
      capacityService.update(this.fd)
        .then(rsp => {
          this.$alert('修改成功！', '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: action => {
            }
          });
          this.$emit('closeDialog', '');
          this.$emit('callback');
        })
        .catch(err => {
          console.error('获取初始化数据出错！', err);
          this.loading = false;
        });
    }
  },
  created () {
    this.initAttr();
    if (this.dlParams.capacityCode) {
      // 如果有身份uuid，则为修改类型
      this.dlType = 'edit';
      this.init();
    } else {
      this.fd.deptCode = this.dlParams.deptCode;
      this.fd.deptName = this.dlParams.deptName;
      this.fd.effectEndDate = new Date('9999-12-31').getTime();
      if (this.dlParams.joinTime) {
        this.fd.effectStartDate = this.dlParams.joinTime;
      } else {
        this.fd.effectStartDate = new Date().getTime(); // 初始化身份有效期起为当日
      }
      this.fd.capacityName = this.dlParams.userName;
      this.fd.userCode = this.dlParams.userCode;
    }
  }
};
</script>
